<template>
  <div id="app">
    <Header id="header"/>
    <div class="mainContent">
      <router-view/>
    </div>
  </div>
</template>

<script>
import '@/assets/my.css'
import Header from './components/Header'

export default {
  name: 'App',
  components: {Header}
}
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue